import React, { useState, useEffect } from 'react';
import FileManager from './FileManager';
import { visibleFiles, hydrateFiles } from './fileLib';
import './FilesLibrary.css';

// Dedicated "Files" screen for an org admin or agent. Manage your own files and see
// the public files inherited (read-only) from your org / MLS. Files are referenced by
// reminders — never copied — so each file is stored once.
function FilesLibrary({ ownerKey, ancestors = [], title = 'Files', subtitle, profileFiles, onToggleProfile }) {
  // Refresh the metadata map from the server, then recompute the inherited list
  // (rev also remounts FileManager so its owned list re-reads).
  const [rev, setRev] = useState(0);
  useEffect(() => { let alive = true; hydrateFiles().then(() => { if (alive) setRev(r => r + 1); }); return () => { alive = false; }; }, []);
  const inherited = visibleFiles({ ownKeys: [], ancestors });   // parents' files relayed down to me
  return (
    <div className="files-container">
      <div className="files-header">
        <h2>{title}</h2>
        <p>{subtitle || 'Upload files to attach to your reminders. Files marked Public are shared (read-only) with lower levels.'}</p>
      </div>
      <FileManager key={rev} ownerKey={ownerKey} inherited={inherited} profileFiles={profileFiles} onToggleProfile={onToggleProfile} />
    </div>
  );
}

export default FilesLibrary;
